
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import {
//   getMonitorGunStatus,
//   getMonitorPileGrid
// } from "@/api/api-operation-service";
import {
  getOrderCurveCharge,
  getOrderCurveTemperature
} from "@/api/api-charge-service";
import echartLine from "./echart-line.vue";
import { echartsJS } from "@/common/add-js";
import i18n from "@/config/i18n";
@Component({
  components: {
    echartLine
  }
})
export default class PiSiteMonitor extends Vue {
  @Prop({ default: "" }) orderNo!: string;
  @Prop({ default: 2 }) deviceType!: number;
  width = 0;
  times: string[] = [];

  loaded = false;
  loaded2 = false;

  /**
   * 默认个度 60
   */
  second = 60;

  /**
   * 电压ichart特征
   */
  pressureFeature = {
    outVoltageList: [i18n.t("orderDetails.outputVoltage") + "(V)", "#FF0000"],
    chargePowerList: [i18n.t("orderDetails.chargingPower") + "(kW)", "#AD95FF"],
    outCurrentList: [i18n.t("orderDetails.outputCurrent") + "(A)", "#14C058"]
  };
  pressureFeatureDc = {
    bclVoltageList: [i18n.t("orderDetails.demandVoltage") + "(V)", "#4BA3F5"],
    outVoltageList: [i18n.t("orderDetails.outputVoltage") + "(V)", "#FF0000"],
    chargePowerList: [i18n.t("orderDetails.chargingPower") + "(kW)", "#AD95FF"],
    bclCurrentList: [i18n.t("orderDetails.demandCurrent") + "(A)", "#14C058"],
    outCurrentList: [i18n.t("orderDetails.outputCurrent") + "(A)", "#6DDFCF"],
    socList: ["SOC％", "#F9DC76"]
  };

  /**
   * 电流ichart特征
   */
  electricityFeature = {
    connectorVoltageList: [i18n.t("orderDetails.cpVoltage") + "(V)", "#4BA3F5"],
    pileTempList: [
      i18n.t("orderDetails.chargerTemperature") + "(°C)",
      "#FF0000"
    ]
  };
  electricityFeatureDc = {
    connectorVoltageList: [i18n.t("orderDetails.cpVoltage") + "(V)", "#4BA3F5"],
    pileTempList: [
      i18n.t("orderDetails.chargerTemperature") + "(°C)",
      "#FF0000"
    ],
    gunTempList: [i18n.t("orderDetails.gunTemperature") + "(°C)", "#6DDFCF"]
  };

  pressureData: object[] = [];

  electricityData: object[] = [];
  chargeData: objAny = {};

  async getOrderCurveCharge() {
    if (!this.orderNo) {
      return;
    }
    const ret = await getOrderCurveCharge({ orderNo: this.orderNo });
    if (ret.status == this["$config"].apiStatus) {
      const data = ret.data[0];
      if (data) {
        this.chargeData = data;
        //开始时间与结束时间相差几秒
        let chargeEndTime = data.chargeEndTime;
        if (
          !chargeEndTime &&
          data.outVoltageList &&
          data.outVoltageList.length > 0
        ) {
          // 没有结束时间，就从数组里取最后一组的时间
          chargeEndTime =
            data.outVoltageList[data.outVoltageList.length - 1].recTime;
        }
        //开始时间与结束时间相差几秒
        this.diffTime(data.chargeBeginTime, chargeEndTime);
        this.times = [
          data.putGunTime,
          data.chargeBeginTime,
          data.chargeEndTime,
          data.pullGunTime
        ].filter(item => {
          return item;
        });
        if (this.deviceType == 2) {
          // 交流
          this.convertEchartData(data, this.pressureFeature, true);
        } else {
          this.convertEchartData(data, this.pressureFeatureDc, true);
        }
        // this.convertEchartData(data, this.pressureFeature, true);
        // this.convertEchartData(data, this.electricityFeature, false);
      }
      this.getOrderCurveTemperature();
      this.loaded = true;
    }
  }
  async getOrderCurveTemperature() {
    if (!this.orderNo) {
      return;
    }
    const ret = await getOrderCurveTemperature({ orderNo: this.orderNo });
    if (ret.status == this["$config"].apiStatus) {
      const data = ret.data[0];
      if (this.deviceType == 2) {
        // 交流
        this.convertEchartData(data, this.electricityFeature, false);
      } else {
        this.convertEchartData(data, this.electricityFeatureDc, false);
      }
    }
    this.loaded2 = true;
  }

  /**
   * @param data 要转换的数据
   * @param data 要转换的数据格式
   * @param isTag  是否是电压
   */
  convertEchartData(data: objAny, dataKeys: objAny, isPressure = false) {
    const varyData = isPressure ? this.pressureData : this.electricityData;
    Object.keys(data).forEach(item => {
      if (Object.keys(dataKeys).includes(item)) {
        const list: object[] = [];
        if (data[item]) {
          data[item].map((vItem: objAny, index: number) => {
            if (
              index == 0 &&
              vItem.recTime != this.chargeData.chargeBeginTime
            ) {
              list.push([this.chargeData.chargeBeginTime, ""]);
            }
            const value = vItem.value;

            list.push([vItem.recTime, value]);
            if (
              index == data[item].length - 1 &&
              vItem.recTime != this.chargeData.chargeEndTime
            ) {
              list.push([this.chargeData.chargeEndTime, ""]);
            }
          });
        }
        const cItem = {
          name: dataKeys[item][0],
          color: dataKeys[item][1],
          data: list
        };

        varyData.push(cItem);
      }
    });
  }

  /**
   * 相差时间
   * @param startTime
   * @param endTime
   */
  diffTime(startTime: string, endTime: string) {
    if (!startTime || !endTime) {
      return;
    }
    const start = Number(new Date(startTime));
    const end = Number(new Date(endTime));
    const diff = (end - start) / 1000; // 得出相差几秒
    const maxIn = 20;

    if (diff / this.second > maxIn) {
      this.second = parseInt(diff / maxIn + "");
    }
  }
  async created() {
    await echartsJS();
    this.getOrderCurveCharge();
  }

  mounted() {
    this.width = (this.$refs.statusEle as Element).clientWidth;
  }
}
